export default () => ({
  roles: [],
  currentRole: {},
})
